import { useTranslation } from 'react-i18next'

import { usePopularProducts } from '@entities/Product'

import { useAddressStore } from '@features/shipping-methods'

import { ProductCarousel } from '@widgets/product-carousel'


import { IMAGE_SIZES, URL_CATEGORY_POPULAR_PRODUCTS } from '@shared/contants'

export default function PopularProductsCarousel () {
  const { t: tp } = useTranslation('product')
  const { shopId } = useAddressStore()
  
  const { popularProducts, loading } = usePopularProducts({
    shop_id: shopId,
    pager: {
      page: 1,
      limit: 20,
    },
    style: IMAGE_SIZES.TABLET,
  })
  
  return (
    <>
      {popularProducts.length > 0 && (
        <ProductCarousel
          link={URL_CATEGORY_POPULAR_PRODUCTS}
          title={tp('popular')}
          products={popularProducts}
          loading={loading}
        />
      )}
    </>
  )
}
